import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OrganisationApi } from 'src/services/organisation/organisation';

export interface OraganisationInterface {
  id: string;
  name: string;
  address: {
    street: string;
    city: string;
    country: string;
  };
  phone: string;
}

const initialState: OraganisationInterface = {
  id: '',
  name: '',
  address: {
    street: '',
    city: '',
    country: '',
  },
  phone: '',
};

export const OraganisationSlice = createSlice({
  name: 'Organisation',
  initialState,
  reducers: {
    saveOrganisation: (
      state: OraganisationInterface,
      action: PayloadAction<OraganisationInterface>
    ) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        OrganisationApi.endpoints.getCompanyList.matchFulfilled,
        (
          state: OraganisationInterface,
          action: PayloadAction<OraganisationInterface>
        ) => {
          return { ...state, ...action.payload };
        }
      )
      .addMatcher(
        OrganisationApi.endpoints.patchOrganisationById.matchFulfilled,
        (
          state: OraganisationInterface,
          action: PayloadAction<OraganisationInterface>
        ) => {
          return { ...state, ...action.payload };
        }
      );
  },
});

export const { saveOrganisation } = OraganisationSlice.actions;

export default OraganisationSlice.reducer;
